import React,{useEffect, useState} from 'react'
import { useParams } from 'react-router-dom'
import { useTranslation } from "react-i18next"
import { Container, Button, Row} from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { getUserDetail, editUser } from '../../../actions/usersActions'
import { getOrigens } from '../../../actions/origensActions'
import FormUser from '../../admin/users/FormUser'
import Swal from 'sweetalert2'

export default function UserEdit() {     
    const { t } = useTranslation()
    const {id} = useParams()
    const {user} = useSelector(state=>state.users)
    const {origens} = useSelector(state=>state.origens) 
    const dispatch = useDispatch()

    const [formState, setFormState] = useState({})
    const {username, password, firstname, lastname, category, nss, dni, address, rol, origen, counter, idUser} = formState

    const handleInputChange = ({target})=>{
        setFormState({
            ...formState,
            [target.name]: target.value
        })
    }

    const handleCheckboxChange  = (e) => {
        setFormState({
            ...formState,
            [e.target.name]: e.target.checked
        })
    }

    const handleEdit = async(e) => {
        e.preventDefault()

        dispatch(editUser(username, password, firstname, lastname, category, nss, dni, address, rol, origen, counter, idUser))
        Swal.fire({
            showConfirmButton: true,
            icon: 'success',
            text: t('users.messageedit')
        })
    }

    useEffect(()=>{
        dispatch(getUserDetail(id))
        dispatch(getOrigens())
    }, [dispatch,id])

    useEffect(() => {
        if (user) {
            setFormState({
                username: user.username,
                password: '',
                firstname: user.firstname,
                lastname: user.lastname,
                category: user.category,
                nss: user.nss,
                dni: user.dni,
                address: user.address,
                rol: user.rol,
                origen: user.origen,
                counter: user.counter,
                idUser: user._id
            })
        }
    }, [user, dispatch, id])
  
    return (
        <Container className='cuerpo'>
            <Row className="text-left custom-card-header-list">
                <Row className="custom-card-buttom">
                    <Button className="btn btn-secondary mb-4 mx-auto" href={`/admin/users`}>
                        <i className="fas fa-arrow-circle-left"></i> {t('users.volver')}
                    </Button>
                </Row>
                <h1>{t('users.user')}: <span className='text-uppercase'>{user?.firstname} {user?.lastname}</span></h1>
                <FormUser submit={handleEdit} isNew={false} inputChange={handleInputChange} handleCheckbox={handleCheckboxChange} state={formState} origens={origens}></FormUser>
            </Row>
        </Container>
    )
}
